// extracted by mini-css-extract-plugin
export var mediaFilterTab = "MediaFilterTab_mediaFilterTab__qsZ7N";
export var inactive = "MediaFilterTab_inactive__44t4o";
export var purple = "MediaFilterTab_purple__9aiXr";
export var yellow = "MediaFilterTab_yellow__Mc10r";
export var rainbow = "MediaFilterTab_rainbow__J5iGI";
export var primary = "MediaFilterTab_primary__DwV1-";
export var rotate = "MediaFilterTab_rotate__kmOQ5";
export var dotty = "MediaFilterTab_dotty__44wWT";